// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-bordered > .panel-heading > .panel-title[data-v-262af14c] {\n  padding-bottom: 10px;\n}\n.page-header-actions[data-v-262af14c] {\n  right: 0px;\n  gap: 1rem;\n  display: flex;\n}\n.page-header-actions button[data-v-262af14c] {\n  gap: 0.5rem;\n  display: flex;\n  align-items: center;\n}\n.page-header-actions button i[data-v-262af14c] {\n  margin-bottom: 0px;\n}\n.vld-overlay.is-active[data-v-262af14c] {\n  height: 100vh;\n  position: fixed;\n}", ""]);
// Exports
module.exports = exports;
